import { getLocalizedAttrValue, getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.bundleLineItems.filter((child)=>!child.isMainBundleLineItem
    ).map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>{
    return (child)=>{
        var ref, ref1;
        const lensColor = getLocalizedAttrValue(child.legacyProduct.masterData.current.variant, 'lensColor', intl.locale);
        const body = !!lensColor ? `${getLocalizedString(child.legacyProduct.masterData.current.name, intl.locale)} - ${lensColor}` : getLocalizedString(child.legacyProduct.masterData.current.name, intl.locale);
        return {
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.legacyProduct.productType}`),
            body,
            type: child.legacyProduct.productType,
            originalPrice: (ref = child.price) === null || ref === void 0 ? void 0 : ref.total.subtotal,
            price: ((ref1 = child.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) || 0,
            sku: child.sku
        };
    };
};

export { mapBundleChildLineItems, toBundleChildLineItem };
//# sourceMappingURL=map-bundle-child-line-items.js.map
